import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/style/common.scss";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

createApp(App)
  .use(store)
  .use(router)
  .use(Vant)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app");
